import React from 'react';
import {
  InventoryCorrectionCheckinReasonLabels,
  InventoryCorrectionCheckinCheckoutReasonLabels,
  inventoryCorrectionReasons
} from "../../constants/securspace-constants";
import type {SelectChangeEvent} from "@mui/material";
import type {GroupedLocationInventoryActivity} from "../../../types/GroupedLocationInventoryActivity";
import SelectInput from "../../SelectInput";
import {SelectOption} from "../../../types/common/SelectOption";

interface ReasonSelectProps {
  value?: string;
  onChange: (event: SelectChangeEvent) => void;
  groupedLocationInventoryActivity?: GroupedLocationInventoryActivity;
}

const ReasonSelect = ({value, onChange, groupedLocationInventoryActivity}: ReasonSelectProps) => {

  const twoExistingActivities = groupedLocationInventoryActivity?.ids.length === 2;
  const checkInCorrectionExists = Boolean(groupedLocationInventoryActivity?.checkInCorrectionId);
  const checkOutCorrectionExists = Boolean(groupedLocationInventoryActivity?.checkOutCorrectionId);

  let options: SelectOption[] = [];
  let doesNotBelongToBuyer: SelectOption;

  if(checkInCorrectionExists || checkOutCorrectionExists) {
    // If a correction exists for this equipment, buyer cannot select 'does not belong to me'
    doesNotBelongToBuyer = {
        value: inventoryCorrectionReasons.ASSET_DOES_NOT_BELONG_TO_BUYER,
        label: "Asset does not belong to me",
        disabled: true
      }
  } else {
    doesNotBelongToBuyer = {
        value: inventoryCorrectionReasons.ASSET_DOES_NOT_BELONG_TO_BUYER,
        label: "Asset does not belong to me",
        disabled: false
      }
    }

  if (twoExistingActivities) {
    // if both check in and check out activity exist for this equipment...
      if (!checkInCorrectionExists && !checkOutCorrectionExists) {
      // and no corrections exist, display all correction reasons
      options = [...InventoryCorrectionCheckinCheckoutReasonLabels, doesNotBelongToBuyer];
    } else if (checkInCorrectionExists && !checkOutCorrectionExists) {
      // if there is an existing check in correction, display only checkout-related reasons
      options = [{
        value: inventoryCorrectionReasons.ASSET_NUMBER_ENTERED_INCORRECTLY,
        label: "Asset number was entered incorrectly"
        },
        {
          value: inventoryCorrectionReasons.ASSET_CHECKED_OUT_ON_WRONG_DATE,
          label: "Asset was checked out on the wrong date"
        },
        doesNotBelongToBuyer
      ]
    } else if (!checkInCorrectionExists && checkOutCorrectionExists) {
      // if there is an existing check out correction, display only checkin-related reasons
      options = [{
        value: inventoryCorrectionReasons.ASSET_NUMBER_ENTERED_INCORRECTLY,
        label: "Asset number was entered incorrectly"
      }, doesNotBelongToBuyer]
    }
  } else {
      // if only the check in exists, display checkin-related reasons
    options = [...InventoryCorrectionCheckinReasonLabels, doesNotBelongToBuyer];
  }

  return (
    <SelectInput id={"ss-select-correction-reason"} label={"Select Reason (required)"} value={value}
                 onChange={onChange} selectData={options}/>
  );
};

export default ReasonSelect;
